import { Grid, Link } from "@nextui-org/react"

import { Content } from "../../ui/layout/content"
import EmailIcon from '../../ui/resources/GL_email.png'

export default ({}) => {
    return (
        <>
            <Content spacerSize={4} contentCss={{backgroundColor: "#111", minHeight: "150px"}}>
                <Grid.Container css={{height: "100%", paddingTop: "20px"}}>
                    <Grid xs={6} sm={4} css={{flexDirection: "column", alignItems: "flex-start"}}>
                        <Link href="/" color="primary" css={{fs: "$xs"}}>Home</Link>
                        <Link href="/opportunities" color="primary" css={{fs: "$xs"}}>Opportunities</Link>
                    </Grid>
                    <Grid xs={6} sm={4} css={{flexDirection: "column", alignItems: "flex-start"}}>
                        <Link color="primary" css={{fs: "$xs"}} href="mailto:team@liinkage.com"><img src={EmailIcon} width={15} style={{marginRight: "5px"}}/>team@liinkage.com</Link>
                    </Grid>
                </Grid.Container>
            </Content>
        </>
    )
}